import type { Resource } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ReactiveDataDocument } from '@warp-drive/core/reactive';
import { withReactiveResponse } from '@warp-drive/core/request';
import type { RequestInfo } from '@warp-drive/core/types/request';
import { query } from '@warp-drive/utilities/json-api';

import { filterText, page, sort } from '../../data/json-api.ts';
import { jsonApiOptions } from '../../lib/json-api.ts';

export class SearchResourcesState {
  @tracked text = '';
  @tracked page = 1;
  @tracked limit = 30;

  get offset(): number {
    return (this.page - 1) * this.limit;
  }
}

interface SearchPagerSignature {
  Args: {
    legend: string;
    state: Readonly<SearchResourcesState>;
    setState: (state: Partial<SearchResourcesState>) => void;
  };
  Blocks: {
    query: [RequestInfo<ReactiveDataDocument<Resource[]>>];
  };
}

export class SearchResources extends Component<SearchPagerSignature> {
  get query() {
    return withReactiveResponse<Resource[]>(
      query(
        DataTypeContent.Resource,
        {
          ...filterText(this.args.state.text),
          ...page(this.args.state),
          ...sort('-rank'),
        },
        jsonApiOptions
      )
    );
  }

  updateText = (event: Event) => {
    this.args.setState({
      ...this.args.state,
      text: (event.target as HTMLInputElement).value,
      page: 1,
    });
  };

  <template>
    <fieldset>
      <legend class="gud-eyebrow">{{@legend}}</legend>
      <div class="form-group">
        <label for="search" class="form-label">Search</label>
        <input
          type="text"
          id="search"
          class="form-control"
          placeholder="Search..."
          value={{@state.text}}
          {{on "change" this.updateText}}
        />
      </div>
    </fieldset>

    <hr class="my-4" />

    {{yield this.query to="query"}}
  </template>
}
